// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 73164) return "css/" + chunkId + ".c3a10e40ce9b3b1c.css";
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7127":"7bcedc1b09688c2a","13440":"eb2635100e7502a0","35261":"c49cd8a794f1159f","64556":"7f82226c73d76e4e"}[chunkId] + ".css";
};